// @ts-nocheck

"use client"

import Link from "next/link"
import Image from "next/image"
import React from "react"
import "./styles.scss"

const MenuBottom = () => {
    return (
        <section className="menu-bottom__wrapper">
            <div className="menu-bottom__container">
                <Link href="tel:+34687111426" className="w-[20px] h-[20px] relative">
                    <Image
                        src="/images/beluxe/icon-phone-mobile.svg"
                        alt="Phone mobile contact with BeLuxe"
                        layout="fill"
                        objectFit="contain"
                        lang="en"
                        loading="eager"
                        quality={100}
                    />
                </Link>
                <Link href="mailto:INFO@BELUXEPROPERTIES.COM" className="w-[20px] h-[20px] relative">
                    <Image
                        src="/images/beluxe/icon-email-mobile.svg"
                        alt="Address e-mail contact with BeLuxe"
                        layout="fill"
                        objectFit="contain"
                        lang="en"
                        loading="eager"
                        quality={100}
                    />
                </Link>
            </div>
        </section>
    )
}

export default MenuBottom